import { render, staticRenderFns } from "./InputRuleBehaviorEditor.vue?vue&type=template&id=5a34e421&"
import script from "./InputRuleBehaviorEditor.vue?vue&type=script&lang=ts&"
export * from "./InputRuleBehaviorEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports